import { IBulkExportStep } from "../../BulkExportStepper.types";

export function getPrevStepIndex(allSteps: IBulkExportStep[], currentIndex: number) {
  const currentReverseIndex = allSteps.length - 1 - currentIndex;
  const reversedSteps = [...allSteps].reverse();
  const prevReversedStepIndex = getNextStepIndex(reversedSteps, currentReverseIndex);

  if (!~prevReversedStepIndex) {
    return -1;
  }

  const prevStepIndex = allSteps.length - 1 - prevReversedStepIndex;
  return prevStepIndex;
}

export function getNextStepIndex(allSteps: IBulkExportStep[], currentIndex: number) {
  const nextStepIndex = allSteps.findIndex((step, stepIndex) => {
    if (!step.visible) {
      return false;
    }
    return stepIndex > currentIndex;
  });
  return nextStepIndex;
}
